export const locale = {
  lang: 'es',
  'section_layout': {
    'REFRESH': 'Refrescar'
  }
};
